import { ProductLine } from './ProductLine';

export default ProductLine;


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/RecommendedProductsTab/ProductLine/index.ts